/* The first question a person answers in this product. It leads with feeling,
   because that is what the product is about — the body-composition answers are
   still here for the people who want them, but they sit at the bottom and they
   are worded plainly, with no "lean out" / "cut" language anywhere.

   The ids are load-bearing (they drive the macro maths and the coach's
   framing) so they never change — only the words a person reads. */
export const GOALS = [
  { id: "feel_better", label: "Feel steadier day to day", icon: "01", desc: "Low mood, low energy, sleep that isn’t working" },
  { id: "train_event", label: "Have something that’s mine", icon: "02", desc: "A routine to come back to, or something to work toward" },
  { id: "get_stronger", label: "Feel stronger in my body", icon: "03", desc: "Gradually handle a bit more than last week" },
  { id: "build_muscle", label: "Build myself back up", icon: "04", desc: "Add some size, eating a little more to support it" },
  { id: "lose_fat", label: "Change how I feel in my body", icon: "05", desc: "Ease weight down slowly, without going hungry" },
];

export const EXPERIENCE = [
  { id: "beginner", label: "Brand new", sub: "0-3 months" },
  { id: "some", label: "Some experience", sub: "3-12 months" },
  { id: "intermediate", label: "Intermediate", sub: "1-3 years" },
  { id: "advanced", label: "Advanced", sub: "3+ years" },
];

export const DAYS = [2, 3, 4, 5, 6, 7];
export const DURATIONS = ["20-30 min", "30-45 min", "45-60 min", "60+ min"];

/* Ordered from "nothing at all" upward, in plain words. Someone with an empty
   living room should see themselves in the first option, not scan past seven
   things they don't own. Ids are unchanged — they map to the exercise library. */
export const EQUIPMENT = [
  { id: "bodyweight", label: "Just me and a floor", desc: "No equipment at all" },
  { id: "dumbbells", label: "A couple of dumbbells" },
  { id: "bench", label: "Somewhere to sit or lie down" },
  { id: "pull_up_bar", label: "Something to hang from" },
  { id: "barbell_rack", label: "A barbell and a rack" },
  { id: "cables", label: "Cables" },
  { id: "machines", label: "Machines" },
  { id: "full_gym", label: "A gym with all of it", desc: "I go to a gym with everything" },
];

export const LIMITATIONS = [
  "Bad knees",
  "Shoulder issues",
  "Lower back pain",
  "Wrist/elbow issues",
  "Hip issues",
  "None — I’m good",
];
